import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const queueRoute: Routes = [
  {
    path: 'queue',
    canActivate: [authGuard, clientIdGuard],
    loadComponent: () =>
      import('../components/queue/queue.component').then(
        (m) => m.QueueComponent
      ),
    children: [
      {
        path: 'alerts',
        loadComponent: () =>
          import('../components/queue/alerts/alerts.component').then(
            (m) => m.AlertsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
    ],
  },
];
